import React from "react";
import SettingsContent from "../../components/Parents/Settings/SettingsContent";
import FatherLayout from "../../components/Parents/FatherLayout";

function Setting() {
    return (
        <FatherLayout title="Ajustes" showWelcomeBanner={true}>
            <SettingsContent/>
        </FatherLayout>
    );
}

export default Setting;
